import * as React from "react";
import { DeliveryDate } from "../../../../../microservices/functions/src/isomorphic/product_availability/delivery_date";
import { ProductResult } from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { formatCurrency } from "../helpers/format_currency";
import { Badges } from "./badges";
import styles from "./catalog_item_box.module.sass";
import Countdown from "react-countdown";
import { useReducer } from "react";
import { getCookie } from "typescript-cookie";

declare let isUserLoggedIn: any;

export type ProductProps = {
  product: ProductResult;
  onRefreshMessage: () => void;
  currentDateTime?: Date;
  membersOnly: Boolean
};

const catalogItemPath = (product: ProductResult) =>
  product.itemType === "SaleProduct"
    ? product.linkPath + "#sale-products"
    : product.linkPath;

const showVipPrice = (product: ProductResult) =>
  product.vipPrice &&
  product.itemType !== "SaleProduct" &&
  product.price - product.vipPrice > 0 &&
  (document.cookie.indexOf("facebook_remarketing=") > -1 ||
    document.cookie.indexOf("user_from_seznam_or_google=") > -1 ||
    document.cookie.indexOf("vip_banner_clicked=") > -1 ||
    document.cookie.indexOf("user_from_mailer=") > -1 ||
    isUserLoggedIn == true) &&
  document.cookie.indexOf("computer_from_our_shop=") === -1;

const countdownEndTime = () => {
  const end = new Date();
  const hour = end.getHours();
  switch (true) {
    case hour >= 0 && hour < 12:
      end.setHours(11, 59, 59);
      return end.toISOString();
    case hour >= 12 && hour < 17:
      end.setHours(16, 59, 59);
      return end.toISOString();
    case hour >= 17 && hour < 23:
      end.setHours(22, 59, 59);
      return end.toISOString();
    case hour >= 23:
      end.setHours(23, 59, 59);
      return end.toISOString();
  }
};

const truncateName = (name: string) => {
  if (name.length >= 85) {
    return name.substr(0, 85) + "...";
  } else {
    return name;
  }
};

const yearFromNow = new Date(
  new Date().setFullYear(new Date().getFullYear() + 1)
);

const Completionist = () => <span>00:00:00</span>;

export const CatalogItemBox = ({
  product,
  currentDateTime,
  onRefreshMessage,
  membersOnly,
}: ProductProps): JSX.Element => {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  let idsToCompare: string[] = [] || "";
  let productId: string;
  let finalCookies: string;
  let isChecked = false;
  let value = "";
  let hideProductDetails = membersOnly && !isUserLoggedIn;

  const handleComparator = (catalogId: string) => {
    productId = catalogId.substr(8, catalogId.length);
    const cookies = getCookie("products_ids_to_compare")?.split("&");
    if (cookies != undefined && cookies.length > 0) {
      idsToCompare = cookies;
      idsToCompare = idsToCompare.filter((e) => e); //removes empty values from array
    }
    if (idsToCompare.includes(productId)) {
      idsToCompare = idsToCompare.filter((e) => e !== productId);
    } else {
      idsToCompare.push(productId);
    }
    onRefreshMessage();

    finalCookies = idsToCompare.toString().replaceAll(",", "&");
    document.cookie =
      "products_ids_to_compare=" +
      finalCookies +
      ";expires=" +
      yearFromNow +
      ";path=/;";
    forceUpdate();
  };

  const isInComparator = (catalogId: string) => {
    productId = catalogId.substr(8, catalogId.length);
    const cookies = getCookie("products_ids_to_compare")?.split("&");
    if (cookies != undefined && cookies.length > 0) {
      idsToCompare = cookies;
    }
    if (idsToCompare.includes(productId)) {
      value = "v porovnávači";
      isChecked = true;
    } else {
      value = "porovnat";
      isChecked = false;
    }
    return isChecked;
  };

  return (
    <li key={product.catalogId}>
      {membersOnly &&
        <div className='sold-badge'>
          <strong>
            {isUserLoggedIn ? "NABÍDKA POUZE PRO ČLENY" : "PRO ČLENY"}
          </strong>
        </div>
      }

      {!hideProductDetails && showVipPrice(product) && (
        <a href={catalogItemPath(product)}>
          <div className="black-friday">
            <p>Letní cena</p>
            <p className="black-friday-price">
              {formatCurrency(product.vipPrice)}
            </p>
          </div>
        </a>
      )}
      <div className="product-box-inner" key={product.catalogId} style={hideProductDetails ? {filter: 'grayscale(100%)'} : {}}>
        <h2 className="title">
          <a href={catalogItemPath(product)}>
            {hideProductDetails ? 'Produkty za nejlepší ceny pouze pro registrované. Registrujte se právě teď!' : truncateName(product.fullName)}
          </a>
        </h2>
        <div className={"row " + styles.row}>
          <div className="col-md-6">
            {!hideProductDetails && product.averageRating * 2 > 70 && (
              <span className="stars medium-stars rating">
                <span
                  style={{ width: (product.averageRating * 2 * 112) / 100 }}
                  className="full"
                />
              </span>
            )}
          </div>
          {!hideProductDetails &&
            <div className={"col-md-6"}>
              <div className="comparator-form">
                <input
                  type="checkbox"
                  id={product.catalogId}
                  value={product.catalogId}
                  defaultChecked={isInComparator(product.catalogId)}
                  onChange={() => handleComparator(product.catalogId)}
                />
                <label htmlFor={product.catalogId}>{value}</label>
              </div>
            </div>
          }
        </div>
        {product.imageUrl && (
          <div className="image-container">
            <a className="image-box" href={catalogItemPath(product)}>
              <img src={product.imageUrl} alt={product.fullName} />
            </a>
          </div>
        )}
        <div className="prices-and-availability" style={hideProductDetails ? {height: 52} : {}}>
          {!hideProductDetails && showVipPrice(product) ? (
            <div
              className="prices"
              style={{ marginTop: -12, position: "relative", display: "grid" }}
            >
              <div className="invisible recommended-price">
                {formatCurrency(product.priceRecommended)}
              </div>
              <strong
                className="available-quantity"
                style={{ color: "#004DA4" }}
              >
                běžná cena
              </strong>
              <strong
                className="current-price"
                style={{ textDecoration: "line-through" }}
              >
                {formatCurrency(product.price)}
              </strong>
            </div>
          ) : (
            <div className="prices">
              <div className="invisible recommended-price">
                {!hideProductDetails && formatCurrency(product.priceRecommended)}
              </div>
              <strong className="current-price">
                {!hideProductDetails && formatCurrency(product.price)}
              </strong>
            </div>
          )}

          <div
            className={
              product.itemType === "SaleProduct"
                ? "availability " + styles.saleProductAvailability
                : "availability"
            }
          >
            {product.itemType === "SaleProduct" ? (
              <strong>zboží 2. jakosti</strong>
            ) : (
              product.currentSupplier && (
                <strong className="available-quantity">
                  {!hideProductDetails && product.currentSupplier.stockQuantityLabel}
                </strong>
              )
            )}

            {!hideProductDetails &&
              <DeliveryDate
                bestShippingOption={
                  product.currentAvailability?.bestShippingOption
                }
                now={currentDateTime}
              />
            }
          </div>
        </div>
        <p className="param-summary">
          {!hideProductDetails && product.reviewsCount > 0 ? (
            <strong className="reviews-summary">
              {product.reviewsCount} hodnocení
            </strong>
          ) : null}
          {hideProductDetails ? 'Výhodná nabídka pouze pro členy. Pro zobrazení se přihlašte.' : product.summary}
        </p>
        <div className="actions-without-hover">
          <a
            className="detail-link button button-primary"
            href={catalogItemPath(product)}
          >
            {hideProductDetails ? 'Přihlásit se nebo registrovat' : 'Detail produktu'}
          </a>
        </div>
      </div>
      {!hideProductDetails && product.badges && <Badges badgeItems={product.badges} />}
    </li>
  );
};
